// extracted by mini-css-extract-plugin
export default {"label":"AssignShipmentForm_label__pAuGN"};